export default __webpack_public_path__ + "static/media/closet3-2048w.e959fcbf.png";